module.exports = __webpack_public_path__ + "img/3.b28efcb3.jpg";